import { initialize, isFeatureEnabled, whenAvailable } from "@vp/ab-reader";
import { useCallback, useEffect, useRef, useState } from "react";
import { useProductStore } from "../store/productPriceDetails.store";

export const useFeatureToggle = (): { isFeatureFlagEnabled: (featureFlag: string) => boolean } => {
  const [isClientAvailable, setIsClientAvailable] = useState(false);
  const evaluatedFlags = useRef<Record<string, boolean>>({});
  const setFeatureFlag = useProductStore(state => state.setFeatureFlag);

  useEffect(() => {
    const fetchFeatureTogglesClient = async () => {
      initialize();
      whenAvailable((available) => {
        if (available) {
          setIsClientAvailable(true);
        }
      }, 3000);
    };

    fetchFeatureTogglesClient();
  }, []);

  const isFeatureFlagEnabled = useCallback(
    (featureFlag: string): boolean => {
      if (!isClientAvailable) {
        return false;
      }

      if (featureFlag in evaluatedFlags.current) {
        return evaluatedFlags.current[featureFlag];
      }

      const isFlagEnabled = isFeatureEnabled(featureFlag);
      evaluatedFlags.current[featureFlag] = isFlagEnabled;
      setFeatureFlag(featureFlag, isFlagEnabled);
      return isFlagEnabled;
    },
    [isClientAvailable],
  );

  return { isFeatureFlagEnabled };
};
